var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !!_vm.status
        ? _c(
            "div",
            { staticClass: "biometry" },
            [
              _c("recipient-biometry-status", {
                attrs: { status: _vm.status, id: _vm.id },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("recipient-info", { attrs: { data: _vm.info } }),
      _c("recipient-bank-detail", { attrs: { data: _vm.bankDetail } }),
      _c(
        "div",
        { staticClass: "el-grid-list" },
        [
          _c("recipient-transfer-settings", {
            attrs: { data: _vm.transferSettings },
          }),
          _c("recipient-anticipation-settings", {
            attrs: { data: _vm.anticipationSettings },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }